import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from "../ui/dialog";
import FileVersionPreview from "./FileVersionPreview";
import { DialogTitle } from "@radix-ui/react-dialog";
import { FileType } from "@/features/files/types/file-type";

export const FilePreviewModal = ({
  file,
  userId,
  onClose,
  editable = false,
  organizationBusinessUnitId,
}: {
  onClose: () => void;
  userId: string;
  file: FileType;
  editable?: boolean;
  organizationBusinessUnitId?: string;
}) => {
  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent className="overflow-auto pt-10">
        <DialogTitle className="sr-only">File Preview</DialogTitle>
        <DialogDescription className="sr-only">
          View the file and all the details
        </DialogDescription>

        <DialogHeader>
          <FileVersionPreview
            userId={userId}
            file={file}
            onDelete={onClose}
            editable={editable}
            organizationBusinessUnitId={organizationBusinessUnitId}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewModal;
